import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthStore } from "./types";

/**
 * One identity per device, unlike `clients-web`. Its multi-account switcher exists because a café
 * counter is shared by a whole shift; an admin account is personal and answers for what it did, so
 * signing a second one in on the same browser would blur exactly the trail that matters here.
 */
const useAuth = create<AuthStore>()(
    persist(
        (set) => ({
            token: null,
            admin: null,

            setAuth: (token, admin) => set({ token, admin }),

            updateAdmin: (admin) => set({ admin }),

            clearAuth: () => set({ token: null, admin: null }),

            /**
             * The server rejected this token, so the identity is gone from the device. The page is
             * replaced rather than routed: a hard load drops every screen still holding data the dead
             * session fetched, which a client-side navigation would leave in memory.
             */
            dropDeadSession: () => {
                set({ token: null, admin: null });
                if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
                    window.location.replace("/login");
                }
            },
        }),
        {
            name: "auth",
            partialize: (state) => ({ token: state.token, admin: state.admin }),
        }
    )
);

export default useAuth;
